import type { FeedbackFormWithCount } from '../../games/feedback-forms-data.js';

import { FormRow } from './form-row.js';

interface FormsListProps {
  rows: FeedbackFormWithCount[];
}

export function FormsList({ rows }: FormsListProps): JSX.Element {
  return (
    <ul className="flex flex-col divide-y divide-border rounded-md border border-border bg-surface-2">
      {rows.map((row) => (
        <FormRow key={row.form.id} row={row} />
      ))}
    </ul>
  );
}
